module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00053-fs8.c851f30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00053-fs8.png
// module id = 206
// module chunks = 0